// extracted by mini-css-extract-plugin
export var buttonContainer = "pricingV2-module--buttonContainer--19bfb";
export var collapsible = "pricingV2-module--collapsible--868c6";
export var collapsibleContainer = "pricingV2-module--collapsibleContainer--1f797";
export var contactsSlider = "pricingV2-module--contactsSlider--4a926";
export var creditsSlider = "pricingV2-module--creditsSlider--32c6a";
export var iconDown = "pricingV2-module--iconDown--d5038";
export var iconUp = "pricingV2-module--iconUp--f9cfa";
export var plans = "pricingV2-module--plans--011f7";
export var platformCards = "pricingV2-module--platformCards--0fd76";
export var platformCardsTitle = "pricingV2-module--platformCardsTitle--f2d22";
export var pricingV2 = "pricingV2-module--pricingV2--48669";
export var styledPlanCard = "pricingV2-module--styledPlanCard--d9301";